import { useEffect, useState } from 'react';
import { getSubscriptionPlans } from '../../lib/use-cases/get-subscription-plans';

function useSubscriptionPlans(includesPlans = []) {
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = async () => {
        const list = await getSubscriptionPlans();

        setPlans(list);
        setIsLoading(false);
    };

    useEffect(() => {
        getData();
    }, []);

    return {
        plans: includesPlans.length === 0 ? plans : includesPlans.map(plan => plans.find(item => item.plan === plan)).filter(Boolean),
        isLoading
    };
}

export {
    useSubscriptionPlans
};
